import { NGROK } from "../../../../APIs";
import { apiClient } from "../../../../utils/apiClient";

export const getPlatformlogs = async (tenantName?: string) => {
    const params = new URLSearchParams();
    if (tenantName?.trim()) {
        params.set("tenantName", tenantName.trim());
    }
    const query = params.toString();
    const url = `${NGROK}/api/server-audit-logs${query ? `?${query}` : ""}`;
    const data = await apiClient({
        method: "GET",
        url: url
    });

    return data;
};
